import DocumentTitle from 'react-document-title';
import { Navigate } from 'react-router-dom';

import { toast } from '@hivebrite/design-system/Toast';

import { ApplicationMentor } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Mentor';
import { useMentoringOutletContext } from 'hb-react/frontoffice/apps/Mentoring/container/ProgramControlledAccess';
import PageNotFound from 'hb-react/frontoffice/apps/Mentoring/pages/PageNotFound';
import { getLowerCaseMentorLabel } from 'hb-react/frontoffice/apps/Mentoring/utils';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

interface ApplyToBeMentorProps {
  disabledAccess?: boolean;
}

export const ApplyToBeMentor = ({ disabledAccess }: ApplyToBeMentorProps) => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const { topic } = useTopicContext();
  const { program } = useMentoringOutletContext();

  if (!program || !currentUser || disabledAccess) {
    return <PageNotFound />;
  }

  if (currentUser.can_be_a_mentor === false) {
    toast.error(
      s__(
        'Mentoring|Your account does not have the permission to apply as a %{label}. Please contact your admin to receive the relevant rights.',
      ).i__({
        label: getLowerCaseMentorLabel(program.mentor_label),
      }),
    );

    return <Navigate to="../../mentors" />;
  }

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: s__('Mentoring|Apply to become a %{label}').i__({
            label: getLowerCaseMentorLabel(program.mentor_label),
          }),
          networkName: getPageTitleFromNetwork(currentNetwork),
          // @ts-expect-error topic type should we reworked
          topicName: topic?.name,
        })}
      />
      <ApplicationMentor program={program} currentUser={currentUser} />
    </>
  );
};
